import { useTranslation } from "react-i18next";
import { UseFormRegister } from "react-hook-form";
import Typography from "@mui/material/Typography";
import TextField from "@mui/material/TextField";
import { GetExtraWorkAgreementQueryResponse } from "api/generatedApi";
import { InputContainer } from "shared/styles/input-container-style";
import { ExtraWorkAgreementFormData } from "../hooks/use-input-validation";
import { Box } from "@mui/material";

interface Props {
  agreement?: GetExtraWorkAgreementQueryResponse;
  disabled: boolean;
  register: UseFormRegister<ExtraWorkAgreementFormData>;
}

export const EditExtraWorkAgreementName = (props: Props) => {
  const { t } = useTranslation();

  return (
    <InputContainer>
      {props.disabled ? (
        <Box sx={{ display: "flex", flexDirection: "column", gap: 1 }}>
          <Typography variant="caption" color={"primary.main"}>
            {t("captions.nameRequiredView")}
          </Typography>
          <Typography variant="body1">{props.agreement?.name}</Typography>
        </Box>
      ) : (
        <Box sx={{ display: "flex", flexDirection: "column", gap: 1 }}>
          <Typography variant="caption" color={"primary.main"}>
            {t("captions.nameRequiredEdit")}
          </Typography>
          <TextField {...props.register("name")} variant="filled" sx={{ width: "auto", minWidth: "50%" }} defaultValue={props.agreement?.name} inputProps={{ maxLength: 40 }} label={t("dashboard.extraWorkAgreements.create.name.input")} />
        </Box>
      )}
    </InputContainer>
  );
};
